import { Component } from "react";

export class Container extends Component {
	
	constructor(props) {
		super(props);

		this.callback = this.callback.bind(this);
		this.getState = this.getState.bind(this);
	}

	callback(state) {
		const newState = this.copyRecursive(state);
		newState.menagement = state.menagement;
		newState.mensuration = state.mensuration;
		newState.comunication = state.comunication;
		this.setState(newState);
	}

	getState() {
		return this.copyRecursive(this.state);
	}

	copyRecursive(original, i = 0) {
		i += 1;
		if(i > 50) return "recursion_error";
		if(typeof original != "object") return original;

		let copy;
		if(original.constructor === Array) copy = []; 
		else copy = {};
		
		for(let key in original) {
			const value = original[key];
			if(!value || typeof value != "object") copy[key] = value;
			else copy[key] = this.copyRecursive(value, i);
		}

		return copy;
	}
}


// WEBPACK FOOTER //
// src/containers/Container.js